<template>
    <div>
        <div class="make-appointment">
            <div class="row">
                <div class="col-md-7 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body">
                            <div class="card-body">
                                <div class="appointment-list d-flex justify-content-between align-items-center">
                                    <div class="doctor-info">
                                        <div class="doctor-details d-flex mb-3">
                                            <figure><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                            <div>
                                                <h3>Dr. Shabnam Das Kar</h3>
                                                <p>Specialist in Functional and Metabolic Medicine</p>
                                            </div>
                                        </div>
                                        <ul class="d-flex online-info">
                                            <li class="online">
                                                <a href="#"><i class="icon icon-video"></i> Online</a>
                                            </li>
                                            <li><img src="../../../../static/website/images/consultation-history.svg" class="icon" />Registration No: 13999/2000</li>
                                        </ul>
                                    </div>
                                    <a href="#" class="btn btn-link btn-blue start mt-2">Start Appointment</a>
                                </div>
                                <div class="add-new d-flex justify-content-end mt-3 pb-5">
                                    <router-link to="/doctor-list" class="btn btn-link btn-gray"><i class="icon icon-plus"></i>Add New Appointment</router-link>
                                </div>
                                <ul class="mt-5 d-flex justify-content-between align-items-center consult-menu mt-5 pt-5">
                                    <li class="text-center py-3 mr-3 border-radius-5">
                                        <router-link to="/symptom-checker"><img src="../../../../static/website/images/stethoscope.svg" /> <span>Symptom Checker</span></router-link>
                                    </li>
                                    <li class="text-center py-3 mr-3 border-radius-5">
                                        <router-link to="/medical-records"><img src="../../../../static/website/images/microscope.svg" /> <span>View Medical Records</span></router-link>
                                    </li>
                                    <li class="text-center py-3 border-radius-5">
                                        <router-link to="/consultation-history"><img src="../../../../static/website/images/Consultations.svg" /> <span>Consultation History</span></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-4 questions">
                            <h3 class="mb-3">Ask a questions</h3>
                            <form class="position-relative dropdown">
                                <select class="mb-4">
                                    <option>Dr. Janis Evans</option>
                                </select>
                                <div class="doctor-details chating-room d-flex">
                                    <figure class="text-center position-relative"><img src="../../../../static/website/images/dr-image.svg" alt="" /> <span class="online"></span></figure>
                                    <div class="dr-status">
                                        <h3>Dr. Shabnam Das Kar</h3>
                                        <p>Typing ...</p>
                                    </div>
                                </div>
                                <div class="chat-section">
                                    <h3 class="text-center pb-3">Today</h3>
                                    <p class="patient-chat mb-4">Good Morning Dr. Janis I’m not feeling very well I’ve got these awfu pains in my stomah and i haven’t been sleeping at well</p>
                                    <p class="dr-chat mb-0">You,ve gt some kind of a stomach infection</p>
                                    <span class="d-block">11:22</span>
                                </div>
                                <div class="textarea position-relative mt-4">
                                    <textarea rows="10" placeholder="Ask Questions from a Doctor..."></textarea>
                                    <button class="button send" type="button"><img src="../../../../static/website/images/send.svg" alt="send" /></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="questions-section">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="bg-white border-radius-5 p-3">
                        <h2 class="text-center my-4">Related Questions</h2>
                        <form class="form-search position-relative d-flex justify-content-center align-items-center mb-5">
                            <button class="btn button search"><i class="icon icon-search"></i></button>
                            <input type="text" name="text" placeholder="Search Question" />
                        </form>
                        <div class="row no-gutters">
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "upgrade-prouser",
        data() {
            return {};
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/website/user/upgrade-pro-user.vue